import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { runInAction } from 'mobx';
import {
    callFindCustomerStockList,
    callFindCollateralList,
    callLendApply,
    callSetCollateralList,
    callCustomerLendApply,
    getFindBusinessTime,
} from '@api';
import { useNavigate } from 'react-router-dom';

const initialState = {
    amount: '10000',
    applyReason: '01',
    applyReasonOther: '',
    borrowLimit: '0',
    borrowedAmount: '0',
    certificateNumber: '',
    applyModalVisible: false,
    loanCstModalVisible: false,
    cstInfoModalVisible: false,
    declareModalVisible: false,
    transInfoModalVisible: false,
    highGradeModalVisible: false,
    HighGradeCollateralSwitch: false,
    certModalVisible: false,
    errMsg: '',
    transType: '',
    loanComplete: false,
    applyDisabled: false,
    canBorrowedAmount: 0,
    canFinancingAmount: 0,
    dailyBorrowingAmount: 0,
    collateralList: [],
    collateralStockUIList: [
        {
            stockNo: '',
            stockName: '',
            stockQty: 0,
            closePrice: 0,
            insiderFlag: 0,
            marketVal: 0,
            accommodating: 0,
            cstQty: 0,
        },
    ],
    notBusinessHour: false,
    loanSwitchVisible: true,
    isLoading: false,
    loadingFailed: false,
    msg: '',
    dailyTransactionLimit: 0,
    singleTransactionLimit: 0,
    singleTransactionMinimum: 0,
    transFlagModalVisible: false,
    optionData: [],
};

const api = {
    findCustomerStockList: callFindCustomerStockList,
    findCollateralList: callFindCollateralList,
    setCollateralList: callSetCollateralList,
    lendApply: callLendApply,
    customerLendApply: callCustomerLendApply,
    getBusinessTime: getFindBusinessTime,
};
const LoadStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        async initStock() {
            const res = await this.findCustomerStockList();
            const userStock = res.data.item;
            console.log(userStock);
            this.assignData({ ...userStock });
            const resCollateral = await this.findCollateralList();
            const collateralList = resCollateral.data.items;
            this.assignData({ collateralList });
        },
        async getLendBusinessTime() {
            const res = await this.getBusinessTime();
            const transType = res.item.code;
            const lendSwitchMessage =
                res.item.switchOffMessage.lendSwitchMessage;
            this.assignData({ transType, lendSwitchMessage });
            // 非營業時間借款功能關閉
            // if (
            //     transType === 'E1' ||
            //     transType === 'E2' ||
            //     transType === 'E3'
            // ) {
            //     // this.updateData('transInfoModalVisible', true);
            //     this.updateData('applyDisabled', true);
            //     this.updateData('notBusinessHour', true);
            // } else if (transType === 'N') {
            //     this.updateData('notBusinessHour', true);
            // } else {
            //     this.updateData('transInfoModalVisible', false);
            //     this.updateData('applyDisabled', false);
            //     this.updateData('notBusinessHour', false);
            // }
            const highGradeSwitch =
                res.item.switchOptions.HighGradeCollateralSwitch;
            if (parseInt(highGradeSwitch)) {
                if (highGradeSwitch === '1') {
                    this.updateData('highGradeCollateralSwitch', true);
                } else {
                    this.updateData('highGradeCollateralSwitch', false);
                }
            } else {
                this.updateData('highGradeCollateralSwitch', false);
            }
            const loanSwitch = res.item.switchOptions.lendSwitch;
            if (parseInt(loanSwitch)) {
                this.updateData('loanSwitchVisible', true);
                if (
                    transType === 'E1' ||
                    transType === 'E2' ||
                    transType === 'E3' ||
                    transType === 'E4'
                ) {
                    this.updateData('transInfoModalVisible', true);
                    this.updateData('applyDisabled', true);
                } else if (transType === 'N') {
                    this.updateData('notBusinessHour', true);
                } else {
                    this.updateData('transInfoModalVisible', false);
                    this.updateData('applyDisabled', false);
                }
                return parseInt(loanSwitch);
            } else {
                this.updateData('loanSwitchVisible', false);
                return parseInt(loanSwitch);
            }
        },
        async apply() {
            // this.updateData('applyDisabled', true);
            this.updateData('isLoading', true);
            const postData = {
                amount: this.amount,
                applyReason: this.applyReason,
                applyReasonOther: this.applyReasonOther,
                lendId: this.lendId,
                certificateNumber: this.certificateNumber,
            };
            const res = await this.lendApply(postData);
            const code = parseInt(res.data.code);
            const message = res.data.message;
            if (res) {
                this.updateData('loanComplete', true);
                this.updateData('applyDisabled', false);
                this.updateData('isLoading', false);
                if (code) {
                    this.updateData('loadingFailed', true);
                    this.updateData('msg', message);
                }
            }
        },
        async setCst(postData) {
            const res = await this.setCollateralList(postData);
            const code = parseInt(res.data.code);
            this.lendId = res.data.item;
            if (res.status === 200 && !code) {
                this.updateData('declareModalVisible', true);
            }
        },
        closeApplyModal() {
            this.applyModalVisible = false;
        },
        closeLoanCstModal() {
            this.loanCstModalVisible = false;
        },
        closeCstInfoModal() {
            this.cstInfoModalVisible = false;
        },
        closeCertModal() {
            this.certModalVisible = false;
        },
        closeDeclareModal() {
            this.declareModalVisible = false;
        },
        closeTransInfoModal() {
            this.transInfoModalVisible = false;
        },
        closeTransFlagModal() {
            this.transFlagModalVisible = false;
        },
        closeHighGradeModal() {
            this.highGradeModalVisible = false;
        },
        async getList() {
            runInAction(async () => {
                const res = await this.findCustomerStockList();
                this.collateralStockUIList =
                    res.data.item.collateralStockUIList.map(item => ({
                        ...item,
                        cstQty: 0,
                    }));
            });
        },
        setCount({ index, value }) {
            this.collateralStockUIList[index].cstQty = value;
        },
        reload() {
            const navigate = useNavigate();
            setTimeout(() => {
                navigate(0);
            }, 2000);
        },
    })); // 3

export default LoadStore; // 2
